<template>
  <main id="create-operator-page" class="page-container">
    <!-- Messaggi di errore e successo -->
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->

    <form class="operator-form" @submit.prevent="onUpdateOperator">
      <!-- ===================== RIGA 1 ===================== -->
      <div class="create-operator-row row-1">
        <!-- Nome Operatore -->
        <div class="field">
          <label for="operator-name">Nome operatore</label>
          <input
            id="operator-name"
            type="text"
            v-model="formData.operatorName"
            placeholder="inserisci"
            required
          />
          <!-- lasciamo required per vedere la modifica nella getAll -->
        </div>

        <div class="radio-fields-container">
          <!-- Radio Dipendente -->
          <div class="field">
            <label for="employee">Dipendente</label>
            <input
              type="radio"
              id="employee"
              value="employee"
              v-model="formData.role"
            />
          </div>

          <!-- Radio Collaboratore -->
          <div class="field">
            <label for="collaborator">Collaboratore</label>
            <input
              type="radio"
              id="collaborator"
              value="collaborator"
              v-model="formData.role"
            />
          </div>
        </div>
      </div>

      <hr />

      <!-- ===================== RIGA 2 ===================== -->
      <div class="create-operator-row row-2">
        <!-- Ragione Sociale -->
        <div class="field">
          <label for="business-name">Ragione sociale</label>
          <input
            id="business-name"
            type="text"
            v-model="formData.companyName"
            placeholder="inserisci"
          />
        </div>

        <!-- Email -->
        <div class="field">
          <label for="email">Email</label>
          <input
            id="email"
            type="email"
            v-model="formData.email"
            placeholder="inserisci"
            required
          />
        </div>

        <!-- Partita IVA -->
        <div class="field">
          <label for="vat-number">P.IVA</label>
          <input
            id="vat-number"
            type="text"
            v-model="formData.vatNumber"
            placeholder="inserisci"
          />
        </div>

        <!-- PEC -->
        <div class="field">
          <label for="pec">Pec</label>
          <input
            id="pec"
            type="email"
            v-model="formData.pec"
            placeholder="inserisci"
          />
        </div>

        <!-- Codice Univoco -->
        <div class="field">
          <label for="unique-code">Codice univoco</label>
          <input
            id="unique-code"
            type="text"
            v-model="formData.uniqueCode"
            placeholder="inserisci"
          />
        </div>

        <!-- Sede Legale -->
        <div class="field">
          <label for="legal-address">Sede legale</label>
          <input
            id="legal-address"
            type="text"
            v-model="formData.legalHeadquarters"
            placeholder="inserisci"
          />
        </div>

        <!-- Bottone Salva, allineato a destra -->
        <div class="save-button-container">
          <button id="create-operator-button" type="submit">Aggiorna</button>
        </div>
      </div>

      <!-- <hr /> -->

      <!-- ===================== RIGA 3 ===================== -->
      <!-- <div class="create-operator-row row-3">
        <div class="field">
          <label for="image">Immagine</label>
          <input
            id="image"
            type="file"
            @change="handleImageUpload"
            accept="image/*"
          />
        </div>
      </div> -->
    </form>
  </main>
</template>

<script>
import { mapActions } from "vuex/dist/vuex.cjs.js";
import { useToast } from "vue-toast-notification";

export default {
  setup() {
    const toast = useToast();
    return { toast };
  },
  name: "EditOperatorPage",
  props: ["operatorId"], // se abbiamo definito props: true nella rotta
  data() {
    return {
      formData: {
        operatorName: "",
        role: "",
        companyName: "",
        email: "",
        vatNumber: "",
        pec: "",
        uniqueCode: "",
        legalHeadquarters: "",
        // image: null,
      },
      // errorMessage: "",
      // successMessage: "",
    };
  },
  methods: {
    ...mapActions(["updateOperator"]),
    /**
     * Recupera i dati dell'operatore da modificare.
     * Viene chiamato appena il componente è montato.
     */
    async fetchOperatorData() {
      try {
        // this.errorMessage = "";
        const response = await this.$axios.get(`auth/${this.operatorId}`);
        // Adatta il percorso a seconda della tua API
        if (response.status === 200) {
          // Popola i campi con i dati ottenuti
          const operatorData = response.data.operator;
          this.formData.operatorName = operatorData.operatorName;
          this.formData.role = operatorData.role;
          this.formData.companyName = operatorData.companyName;
          this.formData.email = operatorData.email;
          this.formData.vatNumber = operatorData.vatNumber;
          this.formData.pec = operatorData.pec;
          this.formData.uniqueCode = operatorData.uniqueCode;
          this.formData.legalHeadquarters = operatorData.legalHeadquarters;
          // Se c'è un URL immagine, decidi se vuoi gestirlo in modo particolare
          // this.formData.image = operatorData.image;

          // this.$nextTick(() => {
          // this.successMessage =
          this.toast.success(
            response.data?.message || "Dati operatore caricati con successo."
          );
          // });
        }
      } catch (error) {
        // this.$nextTick(() => {
        // this.errorMessage =
        this.toast.error(
          error.response?.data?.message ||
            "Impossibile caricare i dati dell'operatore."
        );
        // });
      }
    },

    // handleImageUpload(e) {
    //   const file = e.target.files[0];
    //   if (file) {
    //     this.formData.image = file;
    //   }
    // },

    /**
     * Aggiorna l'operatore esistente
     */
    async onUpdateOperator() {
      try {
        // this.errorMessage = "";
        // this.successMessage = "";

        // Puoi usare un FormData se devi inviare anche file (immagine),
        // altrimenti un JSON semplice se l'API lo consente.
        const payload = {
          operatorName: this.formData.operatorName,
          role: this.formData.role,
          companyName: this.formData.companyName,
          email: this.formData.email,
          vatNumber: this.formData.vatNumber,
          pec: this.formData.pec,
          uniqueCode: this.formData.uniqueCode,
          legalHeadquarters: this.formData.legalHeadquarters,
          // immagine gestita a parte se necessario
        };

        // Esempio di richiesta PATCH
        const response = await this.updateOperator({
          operatorId: this.operatorId,
          payload,
        });

        if (response.status === 200) {
          // this.$nextTick(() => {
          // this.successMessage =
          this.toast.success(
            response.data?.message || "Operatore aggiornato con successo!"
          );
          // });
          // redirect alla pagina operators
          setTimeout(() => {
            this.$router.push({ name: "operators" });
          }, 1000);
        }
      } catch (error) {
        // Se arrivi qui, c’è un errore => error.response esiste
        if (error.response?.status === 409) {
          // Gestisci il conflitto
          // this.$nextTick(() => {
          // this.errorMessage =
          this.toast.error(
            error.response.data?.details ||
              "Conflitto nei dati, chiave univoca 'Email' già presente."
          );
          // });
        } else {
          // this.$nextTick(() => {
          // this.errorMessage =
          this.toast.error(
            error.response?.data?.details ||
              error.response?.data?.error ||
              "Errore durante l'aggiornamento dell'articolo."
          );
          // });
        }
        // this.successMessage = "";
      }
    },
  },
  /**
   * Appena montato, recupera i dati dall'API
   */
  mounted() {
    this.fetchOperatorData();
  },
};
</script>

<style src="@/css/CreateOperatorPage.css"></style>
<!-- Usa lo stesso CSS di CreateOperatorPage, oppure duplicalo in EditOperatorPage.css se vuoi differenziarlo. -->
